import { ErrorHandler } from '@angular/core';
import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { NotificationService } from './shared/services/notification.service';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideServiceWorker } from '@angular/service-worker';
import { FacebookLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from '@abacritt/angularx-social-login';
import { withInMemoryScrolling } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { GuestService } from './shared/services/guest.service';
import { DrawNamesService } from './shared/services/drawnames.service';
import { MemberService } from './shared/services/member.service';
import { UserService } from './shared/services/user.service';
import { ProductService } from './shared/services/product.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { GlobalErrorHandler } from './shared/global-error-handler';
import { SEOService } from './shared/services/seo.service';
export const appConfig: ApplicationConfig = {
    providers: [
        MatSidenavModule, MatSnackBarModule, SocialLoginModule, 
        ProductService, UserService, MemberService, DrawNamesService, GuestService, AuthGuard, NotificationService, SEOService,
        provideAnimations(),
        provideHttpClient(
            withFetch(),
            withInterceptors([AuthInterceptor])
        ),
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        provider: new FacebookLoginProvider('2187096558222688'),
                    },
                ],
            } as SocialAuthServiceConfig,
        },
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes,
          withInMemoryScrolling({
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
          }),
          ),
          //{ provide: LOCALE_ID, useValue: 'nl' },
          { provide: 'googleTagManagerId', useValue: 'GTM-MFQK4FB' },
          provideClientHydration(),
          provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
          })],
          
  };